// augmentations to @sinclair-digital/sbg-storyline-components/models/ValidatedField
export interface Validator<T> {
    errorMessage?: string;
    value: T;
}

export const toValidatedField = <T>(value: T): Validator<T> => ({
    errorMessage: undefined,
    value,
});
